import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from "@mui/material";
import { AppButton } from "components/common/buttons";

const DeleteDocumentTypeDialog = ({
  open,
  documentType,
  onClose,
  onConfirm,
  submitting = false,
}) => {
  return (
    <Dialog open={open} onClose={submitting ? undefined : onClose} fullWidth maxWidth="xs">
      <DialogTitle sx={{ fontWeight: 600, fontFamily: "Inter, sans-serif" }}>
        Xác nhận xóa
      </DialogTitle>
      <DialogContent dividers>
        <DialogContentText component="div" sx={{ fontFamily: "Inter, sans-serif" }}>
          Bạn có chắc chắn muốn xóa loại tài liệu:
          <Typography
            component="div"
            sx={{ mt: 1, fontWeight: 600, color: "text.primary", wordBreak: "break-word" }}
          >
            {documentType?.Name || documentType?.name || ""}
          </Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2 }}>
        <AppButton variant="outlined" onClick={onClose} disabled={submitting}>
          Hủy
        </AppButton>
        <Button color="error" variant="contained" onClick={onConfirm} disabled={submitting} disableElevation>
          Xóa
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteDocumentTypeDialog;
